// The checkout's frame: the backdrop panel behind the flow (and behind the
// sign-in gate and the booking options), and the bar with Close / "Back to
// options" over it. It was hardcoded gray and white, so it stayed light
// on a dark site. A host page can now dress it through these variables,
// set on the component's element (they inherit into its shadow root); unset,
// each falls back to exactly the colour it always was, so the hosted widget
// and partners' embeds look the same. Website v2 sets them from the site's
// palette (puck-config themes/bookingComponents.ts).

/** The variables, for the page that sets them. */
export const CHECKOUT_FRAME_VARS = {
  /** Behind the flow (was gray-50). */
  frame: "--checkout-frame",
  /** The bar (was white). */
  bar: "--checkout-frame-bar",
  /** The bar's bottom rule (was gray-200). */
  rule: "--checkout-frame-rule",
  /** Close and "Back to options" (were gray-600). */
  muted: "--checkout-frame-muted",
  /** "Back to options" hovered (was gray-900). */
  ink: "--checkout-frame-ink",
  /** Close hovered (was gray-100). */
  hover: "--checkout-frame-hover",
} as const;

// Whole class names, so Tailwind sees them in the source.
export const CHECKOUT_FRAME_CLASSES = {
  frame: "bg-[var(--checkout-frame,var(--color-gray-50))]",
  header: "bg-[var(--checkout-frame-bar,var(--color-white))] border-[var(--checkout-frame-rule,var(--color-gray-200))]",
  link: "text-[var(--checkout-frame-muted,var(--color-gray-600))] hover:text-[var(--checkout-frame-ink,var(--color-gray-900))]",
  close: "text-[var(--checkout-frame-muted,var(--color-gray-600))] hover:bg-[var(--checkout-frame-hover,var(--color-gray-100))]",
} as const;
